import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X, Phone, Flame } from "lucide-react";
import { company, nav } from "../mock";

const Header = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className="sticky top-0 left-0 w-full z-50 shadow-md"
      style={{ backgroundColor: "#343434" }}
      data-testid="site-header"
    >
      <div className="max-w-[1140px] mx-auto px-5 py-3 flex items-center justify-between">
        <a href="#home" onClick={(e) => { e.preventDefault(); go("#home"); }} className="flex items-center gap-2.5" data-testid="header-logo">
          <span className="w-10 h-10 rounded-sm bg-fire flex items-center justify-center">
            <Flame className="text-white" size={20} />
          </span>
          <span className="leading-none">
            <span className="block font-medium text-white text-xl tracking-wide">Stove Scotland</span>
            <span className="block uppercase tracking-[0.22em] text-fire text-[9px] mt-1 font-light">
              Supply - Install - Maintain
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {nav.map((n) => (
            <a
              key={n.label}
              href={n.href}
              onClick={(e) => { e.preventDefault(); go(n.href); }}
              className="nav-link text-white text-[15px] font-normal hover:text-fire"
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </a>
          ))}
          <button
            onClick={() => navigate("/showcase")}
            className="nav-link text-white text-[15px] font-normal hover:text-fire"
            data-testid="nav-gallery"
          >
            Gallery
          </button>
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a href={company.phoneHref} className="flex items-center gap-2 text-white font-medium" data-testid="header-phone">
            <Phone size={16} className="text-fire" />
            {company.phone}
          </a>
          <button onClick={() => go("#quote")} className="btn-fire px-5 py-2 text-[15px]" data-testid="header-quote-button">
            Free Quote
          </button>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-toggle">
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10" style={{ backgroundColor: "#343434" }} data-testid="mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-4">
            {nav.map((n) => (
              <a key={n.label} href={n.href} onClick={(e) => { e.preventDefault(); go(n.href); }} className="text-white">
                {n.label}
              </a>
            ))}
            <button onClick={() => { setOpen(false); navigate("/showcase"); }} className="text-white text-left">
              Gallery
            </button>
            <a href={company.phoneHref} className="text-fire font-medium flex items-center gap-2">
              <Phone size={16} /> {company.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
